import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Authentication uses a secure httpOnly session cookie only.
// No localStorage/query-token fallback — the cookie is the single source.
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Emit lightweight events so a global banner can reflect backend reachability.
// A request that returns ANY HTTP status means the backend is reachable; only a
// network-level failure (no response) counts as "backend down".
function emit(name) {
  if (typeof window !== "undefined") window.dispatchEvent(new Event(name));
}
api.interceptors.response.use(
  (res) => { emit("maziara:backend-ok"); return res; },
  (err) => {
    if (!err.response) emit("maziara:backend-down");
    else emit("maziara:backend-ok");
    return Promise.reject(err);
  }
);

export default api;
